module.exports = "<div ng-cloak ng-if=$ctrl.showDiscount() class=\"c-membership c-membership__banner\" ng-class=\"{ 'c-membership__header' : $ctrl.header }\"> <span ng-if=!$ctrl.short> Your membership discount is currently active and will be applied during the payment step of the checkout </span> <span ng-if=$ctrl.short> Your membership discount will show on the payment screen before completion </span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/basket/views/membershipBanner.html
// module id = 698
// module chunks = 0